var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('outdoor-layout-comp',[_c('div',{attrs:{"slot":"AppContent"},slot:"AppContent"},[_c('password-reset-comp')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }